import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { ForeignExchanges, ForeignExchangeFilters } from '../../models/ForeignExchange';

const useForeingExchangeService = () => {
    const { doGet } = useFetch();

    const [fetchingGetForeignExchanges, setfetchingGetForeignExchange] = useState(false);
    const [fetchingGetForeignExchangesByDate, setFetchingGetForeignExchangesByDate] = useState(false);

    const getForeignExchange = (currencyFilters: ForeignExchangeFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(currencyFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.FOREIGN_EXCHANGE.GET_FOREIGN_EXCHANGE}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setfetchingGetForeignExchange
        });

        return {
            getForeignExchange,
            fetchingGetForeignExchanges
        };
    };

    const getForeignExchangesByDate = (currencyId: number, year: number, month?: number, events: ServiceEvents = {}) => {
        const params = new URLSearchParams({
            currency_id: currencyId.toString(),
            year: year.toString()
        });

        if (month) {
            params.append('month', month.toString());
        }

        const url = `${EndPoints.FOREIGN_EXCHANGE.GET_FOREIGN_EXCHANGE_BY_DATE}?${params.toString()}`;
        
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetForeignExchangesByDate
        });
    };

    return {
        fetchingGetForeignExchanges,
        fetchingGetForeignExchangesByDate,
        getForeignExchange,
        getForeignExchangesByDate
    };
}

export default useForeingExchangeService;
